import { render, staticRenderFns } from "./ctccPhoneAuth.vue?vue&type=template&id=cb4df4b6&"
import script from "./ctccPhoneAuth.vue?vue&type=script&lang=js&"
export * from "./ctccPhoneAuth.vue?vue&type=script&lang=js&"
import style0 from "./ctccPhoneAuth.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports